

export default function Benefit2() {
	return (
		<>

			<div className="tf-widget-benefit-v2 background-black">
				<div className="themeflat-container">
					<div className="tf-benefit-v2">
						<div className="title-box-v2 center-title-box title-large">
							<span className="sub-title wow fadeInUp animated">Key factors that power accurate football predictions</span>
							<h2 className="title-section wow fadeInUp animated">Predixio’s Advantages</h2>
						</div>
						<div className="row benefit-v2">
							<div className="col-12 col-sm-6 col-md-6 col-lg-3">
								<div className="benefit-item-v2 wow fadeInUp animated" data-wow-delay="0.1s">
									<div className="benefit-number">
										<span className="number">01</span>
									</div>
									<div className="line-benefit" />
									<div className="box-content-benefit">
										<h6 className="title-benefit">Deep Learning Models</h6>
										<p className="description-benefit">I
											Neural networks and gradient boosting algorithms for maximum accuracy.
										</p>
									</div>
								</div>
							</div>
							<div className="col-12 col-sm-6 col-md-6 col-lg-3">
								<div className="benefit-item-v2 wow fadeInUp animated" data-wow-delay="0.3s">
									<div className="benefit-number">
										<span className="number">02</span>
									</div>
									<div className="line-benefit" />
									<div className="box-content-benefit">
										<h6 className="title-benefit">Rich Feature Set</h6>
										<p className="description-benefit">
											Team form, player stats, head-to-head records, external factors, and odds.
										</p>
									</div>
								</div>
							</div>
							<div className="col-12 col-sm-6 col-md-6 col-lg-3">
								<div className="benefit-item-v2 wow fadeInUp animated" data-wow-delay="0.5s">
									<div className="benefit-number">
										<span className="number">03</span>
									</div>
									<div className="line-benefit" />
									<div className="box-content-benefit">
										<h6 className="title-benefit">Multiple Predictions</h6>
										<p className="description-benefit">
											Win/Draw/Loss, exact scores, over/under markets, and player performance.
										</p>
									</div>
								</div>
							</div>
							<div className="col-12 col-sm-6 col-md-6 col-lg-3">
								<div className="benefit-item-v2 wow fadeInUp animated" data-wow-delay="0.7s">
									<div className="benefit-number">
										<span className="number">04</span>
									</div>
									<div className="line-benefit" />
									<div className="box-content-benefit">
										<h6 className="title-benefit">Real-time Updates</h6>
										<p className="description-benefit">
											Models retrain weekly with fresh data for improved predictions and accuracy.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
